import {
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Stack,
  Theme,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ProfileContentProps } from '../../types';
import { ChangeEmailForm } from '../../../../components/forms/ChangeEmailForm/ChangeEmailForm';
import { ChangePhoneForm } from '../../../../components/forms/ChangePhoneForm/ChangePhoneForm';
import { TelegramLoginCodesSection } from '../../../../components/features/TelegramLoginCodesSection/TelegramLoginCodesSection';
import { AdminPanel } from '../AdminPanel/AdminPanel';
import { ChangeBiometricAuthForm } from '../../../../components/forms/ChangeBiometricAuthForm/ChangeEmailForm';
import { availableLanguages } from '../../../../constants/language';
import { isReactNative } from '../../../../common/utils/reactNativeHelpers';
import { syncNotificationLanguage } from '../../../../common/utils/syncNotificationLanguage';
// import { ChangePasswordForm } from '../../../../components/forms/ChangePasswordForm/ChangePasswordForm';

export const ProfileContent = ({
  user,
  accessToDashboard,
  onNavigate,
  onVerificationTypeChange,
}: ProfileContentProps) => {
  const { t, i18n } = useTranslation();

  return (
    <Stack sx={{ padding: '20px 8px' }}>
      <Typography align="center" color="common.white">
        {t('profilePage.title')}
      </Typography>

      {accessToDashboard && <AdminPanel onNavigate={onNavigate} />}

      <ChangePhoneForm
        phone={user?.phone}
        cb={() => onVerificationTypeChange('phone')}
        btnText={
          user?.phone
            ? t('profilePage.changeFieldBtnText')
            : t('profilePage.addBtnText')
        }
      />

      <ChangeEmailForm
        email={user?.email}
        formTitle={`${
          user?.email
            ? t('profilePage.changeFieldBtnText')
            : t('profilePage.addBtnText')
        } ${t('userAuth.emailPlaceholder')}`}
        btnText={
          user?.email
            ? t('profilePage.changeFieldBtnText')
            : t('profilePage.addBtnText')
        }
        cb={() => onVerificationTypeChange('email')}
      />

      {/* <ChangePasswordForm cb={() => onVerificationTypeChange('password')} /> */}

      <Stack sx={{ mt: 2 }}>
        <TelegramLoginCodesSection variant="dark" />
      </Stack>

      <Stack sx={{ marginTop: '30px', gap: '30px', padding: '0 12px' }}>
        <Typography align="center" color="common.white">
          {t('profilePage.sectionPreferenceTitle')}
        </Typography>
        {isReactNative ? (
          <ChangeBiometricAuthForm
            cb={() => ({})}
            fieldLabel={t('profilePage.biometricAuthLabel')}
            useBiometric={user?.useBiometric}
          />
        ) : null}
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ gap: '15px' }}
        >
          <Typography color="common.white">
            {t('profilePage.currentLanguage')}
          </Typography>
          <Select
            input={<OutlinedInput notched={false} />}
            value={localStorage.getItem('LANGUAGE') || ''}
            label="Language"
            onChange={(event: SelectChangeEvent) => {
              localStorage.setItem('LANGUAGE', event.target.value);
              i18n.changeLanguage(event.target.value);
              syncNotificationLanguage(event.target.value);
            }}
            sx={(theme: Theme) => ({
              outline: '0',
              minWidth: '120px',
              borderRadius: '8px',
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              color: theme.palette.green.main,
              alignContent: 'center',
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.green.light,
              },

              '.MuiOutlinedInput-notchedOutline': {
                borderColor: 'none',
                hover: {
                  border: 'none',
                },
              },
              '& .MuiSelect-select': {
                padding: '5px 14px',
                display: 'flex',
                alignItems: 'center',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: theme.palette.green.main,
              },
            })}
          >
            {availableLanguages.map((item, index) => (
              <MenuItem key={item.value + index} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </Stack>
      </Stack>
    </Stack>
  );
};
